import httpsCustomURL from '../../config/httpsCustomURL'

export const uploadProductFileToPreSignedURL = (preSignedURL, file) => {
  return httpsCustomURL.put(preSignedURL, file)
}
